module.exports = __webpack_public_path__ + "img/testEnvBg.b0daeece.png";